import { RxJsonSchema, toTypedRxJsonSchema, ExtractDocumentTypeFromTypedRxJsonSchema } from 'rxdb';

export const F_FAMTARIFQTE_SCHEMA_LITERAL = {
    title: 'Schéma FamTarifQtes',
    description: 'Décrit les spécificités tarifaires par famille',
    version: 0,
    keyCompression: false,
    primaryKey: { key : 'CBMARQ_PK', fields : ['CBMARQ'], separator : '' },
    type: 'object',
    properties: {
        CBMARQ_PK: { type: 'string', maxLength : 10 },
        CBMARQ: { type: 'number' },
        FA_CODEFAMILLE: { type: 'string' },
        FQ_REFCF: { type: 'string' },
        FQ_BORNEINF: { type: ['number', 'null'] },
        FQ_BORNESUP: { type: ['number', 'null'] },
        FQ_REMISE01REM_VALEUR: { type: ['number', 'null'] },
        FQ_REMISE01REM_TYPE: { type: ['number', 'null'] },
        FQ_REMISE02REM_VALEUR: { type: ['number', 'null'] },
        FQ_REMISE02REM_TYPE: { type: ['number', 'null'] },
        FQ_REMISE03REM_VALEUR: { type: ['number', 'null'] },
        FQ_REMISE03REM_TYPE: { type: ['number', 'null'] }
    },
    required: [ 'CBMARQ', 'FA_CODEFAMILLE', 'FQ_REFCF']
} as const;

const schemaTyped = toTypedRxJsonSchema(F_FAMTARIFQTE_SCHEMA_LITERAL);
export type RxFFamTarifQteDocumentType = ExtractDocumentTypeFromTypedRxJsonSchema<typeof schemaTyped>;
export const F_FAMTARIFQTE_SCHEMA: RxJsonSchema<RxFFamTarifQteDocumentType> = F_FAMTARIFQTE_SCHEMA_LITERAL;